var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeterminePump(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 533,
    height: 605,
    viewBox: "0 0 533 605",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M363.71 133.088L307.494 133.054C304.194 133.029 299.5 136.618 299.564 140.644V158.569H296.94L296.903 140.574C296.935 135.344 301.775 130.719 307.438 130.735L363.736 130.699L363.71 133.088Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M363.059 167.844V172.554V167.844Z",
    fill: "#131F2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M363.059 167.844V172.554",
    stroke: "#F7F9F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M392.032 163.824H389.868H392.032Z",
    fill: "#131F2E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M392.032 163.824H389.868",
    stroke: "#F7F9F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M402.249 163.812H400.085H402.249Z",
    fill: "#131F2E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M402.249 163.812H400.085",
    stroke: "#F7F9F9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M302.977 204.811H271.645V211.912H302.977V204.811Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M275.659 158.36V140.156C275.65 136.311 271.486 133.116 268.224 133.042H222.056V130.705H268.188C273.154 130.743 278.142 134.913 278.137 140.225V158.359L275.659 158.36Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M305.451 159.045H269.172V204.811H305.451V159.045Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M280.714 157.467H273.294V159.045H280.714V157.467Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M302.152 157.467H294.731V159.045H302.152V157.467Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M222.172 127.482H219.698V136.162H222.172V127.482Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M214.751 205.598H151.262V211.121H214.751V205.598Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M219.698 106.965H146.314V205.598H219.698V106.965Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M146.316 127.482H143.842V136.162H146.316V127.482Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M158.585 116.53C158.637 115.841 159.453 114.851 160.221 114.877H205.7C206.445 114.858 207.287 115.685 207.31 116.419V140.301",
    fill: "#131F2E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M158.585 116.53C158.637 115.841 159.453 114.851 160.221 114.877H205.7C206.445 114.858 207.287 115.685 207.31 116.419V140.301",
    stroke: "#F7F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M175.174 118.801H162.806V133.004H175.174V118.801Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M158.56 116.963L158.572 140.192C158.536 140.902 159.389 141.835 160.17 141.856L205.075 141.853C206.152 141.881 206.988 141.541 207.309 140.353",
    fill: "#131F2E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M158.56 116.963L158.572 140.192C158.536 140.902 159.389 141.835 160.17 141.856L205.075 141.853C206.152 141.881 206.988 141.541 207.309 140.353",
    stroke: "#F7F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M172.7 123.535H165.279V124.324H172.7V123.535Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M172.7 125.113H165.279V127.481H172.7V125.113Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M203.208 118.801H181.771V133.004H203.208V118.801Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M199.085 121.957H185.893V129.058H199.085V121.957Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M386.143 475.486H402.758H386.143Z",
    fill: "#131F2E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M386.143 475.486H402.758",
    stroke: "#F7F9F9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M402.577 461.328H386.107H402.577Z",
    fill: "#131F2E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M402.577 461.328H386.107",
    stroke: "#F7F9F9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M391.317 294.883H400.684H391.317Z",
    fill: "#131F2E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M391.317 294.883H400.684",
    stroke: "#F7F9F9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M391.22 218.121H400.857H391.22Z",
    fill: "#131F2E"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M391.22 218.121H400.857",
    stroke: "#F7F9F9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M357.035 240.499H439.813V206.402H426.635C425.442 206.117 424.806 205.578 424.558 204.587V185.951C424.719 185.56 425.006 185.224 425.552 185.084H439.85L439.725 155.63H424.377V148.443H413.184L413.232 117.205L422.433 117.219L422.481 110.936H385.741V117.252H395.04V148.602H372.383V155.74H356.972V184.999H371.333C371.931 185.125 372.269 185.451 372.386 185.92V204.71C372.133 205.677 371.36 206.359 370.264 206.566H357.035V240.499Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M368.794 169.409V164.078L372.812 163.111L372.879 149.035L395.538 149.055V116.817H386.216L386.238 111.389L421.968 111.379L421.944 116.788L412.729 116.76L412.681 148.887L423.864 148.882L423.928 162.95L428.346 163.606L428.526 169.606L368.794 169.409Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M416.439 200.188H380.694V603.999H416.439V200.188Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M400.633 598.749C400.633 599.612 399.662 600.312 398.463 600.312C397.264 600.312 396.293 599.612 396.293 598.749C396.293 597.885 397.264 597.186 398.463 597.186C399.662 597.185 400.633 597.884 400.633 598.749Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M408.269 594.172H396.014V596.852H408.269V594.172Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M409.289 467.312H399.077V478.033H409.289V467.312Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M397.186 515.552C390.399 515.39 389.745 515.672 387.355 512.536V355.523H391.058V510.973L396.802 511.978L397.186 515.552Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M395.374 508.968L395.31 505.832L391.792 503.943V477.094H412.281V504.021L408.685 505.871L408.727 509.009L395.374 508.968Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M391.609 508.443V510.891L398.198 517.998H410.296V512.076H412.191V508.443H391.609Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M413.271 574.18C413.271 575.228 412.785 576.08 412.187 576.082C411.586 576.084 411.101 575.236 411.101 574.187C411.101 574.185 411.101 574.183 411.101 574.18C411.098 573.131 411.584 572.279 412.184 572.277C412.783 572.275 413.27 573.123 413.271 574.172C413.271 574.175 413.271 574.18 413.271 574.18Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M413.271 566.139C413.271 567.187 412.785 568.039 412.187 568.041C411.586 568.043 411.101 567.195 411.101 566.146C411.101 566.144 411.101 566.142 411.101 566.139C411.098 565.09 411.584 564.238 412.184 564.236C412.783 564.234 413.27 565.082 413.271 566.131C413.271 566.133 413.271 566.137 413.271 566.139Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M413.271 557.651C413.271 558.7 412.785 559.552 412.187 559.554C411.586 559.556 411.101 558.708 411.101 557.659C411.101 557.657 411.101 557.655 411.101 557.652C411.098 556.604 411.584 555.752 412.184 555.75C412.783 555.748 413.27 556.596 413.271 557.644C413.271 557.646 413.271 557.651 413.271 557.651Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M413.271 549.388C413.271 550.436 412.785 551.288 412.187 551.29C411.586 551.292 411.101 550.444 411.101 549.396C411.101 549.394 411.101 549.392 411.101 549.389C411.098 548.34 411.584 547.488 412.184 547.486C412.783 547.484 413.27 548.332 413.271 549.382V549.388Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M413.271 541.235C413.271 542.284 412.785 543.136 412.187 543.138C411.586 543.14 411.101 542.292 411.101 541.243C411.101 541.241 411.101 541.239 411.101 541.236C411.098 540.188 411.584 539.336 412.184 539.334C412.783 539.332 413.27 540.18 413.271 541.229C413.271 541.229 413.271 541.233 413.271 541.235Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M413.271 533.306C413.271 534.354 412.785 535.206 412.187 535.208C411.586 535.21 411.101 534.362 411.101 533.314C411.101 533.312 411.101 533.31 411.101 533.307C411.098 532.258 411.584 531.406 412.184 531.404C412.783 531.402 413.27 532.25 413.271 533.3V533.306Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M391.789 575.879L399.373 581.249L404.517 581.327L412.281 575.879L412.463 517.207H391.79L391.789 575.879Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M413.271 590.484C413.271 591.533 412.785 592.385 412.187 592.387C411.586 592.389 411.101 591.541 411.101 590.491C411.101 590.489 411.101 590.487 411.101 590.484C411.098 589.436 411.584 588.584 412.184 588.582C412.783 588.58 413.27 589.428 413.271 590.477C413.271 590.477 413.271 590.482 413.271 590.484Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M413.271 582.332C413.271 583.381 412.785 584.232 412.187 584.234C411.586 584.236 411.101 583.389 411.101 582.339C411.101 582.337 411.101 582.335 411.101 582.332C411.098 581.283 411.584 580.432 412.184 580.43C412.783 580.428 413.27 581.275 413.271 582.324C413.271 582.327 413.271 582.33 413.271 582.332Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M411.334 580.771H392.951V594.172H411.334V580.771Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M409.289 379.76H399.077V392.267H409.289V379.76Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M412.354 392.268H391.929V468.205H412.354V392.268Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M410.312 363.678H398.057V380.652H410.312V363.678Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M410.312 355.639H398.057V361.893H410.312V355.639Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M412.354 361H396.014V364.574H412.354V361Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M413.376 349.385H383.759V356.532H413.376V349.385Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M410.312 314.543H398.057V320.797H410.312V314.543Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M386.846 299.575C386.955 298.468 386.748 296.735 387.994 295.778C389.97 294.493 391.148 293.563 391.951 291.311V250.438C391.74 248.172 390.02 245.978 387.818 244.67L388.632 241.393H391.696L392.319 244.576C394.299 246.185 395.234 247.928 395.462 250.306L395.59 291.532C394.324 295.342 392.565 296.724 390.772 298.829L386.846 299.575Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M386.95 297.568H391.801C392.436 297.568 392.95 297.92 392.95 298.35V320.908C392.95 321.339 392.435 321.69 391.801 321.69H386.95C386.316 321.69 385.802 321.339 385.802 320.908V298.35C385.802 297.919 386.316 297.568 386.95 297.568Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M412.353 320.797H384.779V331.517H412.353V320.797Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M414.396 331.518H382.736V348.492H414.396V331.518Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M410.312 226.99H398.057V308.289H410.312V226.99Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M411.333 307.396H397.035V314.544H411.333V307.396Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M431.758 172.494H365.375V176.068H431.758V172.494Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M378.548 200.241V176.175L382.633 172.602H414.287L418.314 176.12V200.241L416.24 202.055H380.591L378.548 200.241Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M356.946 169.84H439.814H356.946Z",
    fill: "#131F2E"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M356.946 169.84H439.814",
    stroke: "#F7F9F9"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M409.289 108.17H399.077V222.524H409.289V108.17Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M411.333 221.631H397.035V227.885H411.333V221.631Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M391.44 594.617C391.44 595.604 390.754 596.404 389.908 596.404C389.061 596.404 388.376 595.604 388.376 594.617C388.376 593.631 389.061 592.83 389.908 592.83C390.754 592.83 391.44 593.63 391.44 594.617Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M391.44 586.576C391.44 587.563 390.754 588.363 389.908 588.363C389.061 588.363 388.376 587.563 388.376 586.576C388.376 585.59 389.061 584.789 389.908 584.789C390.754 584.789 391.44 585.59 391.44 586.576Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M391.44 578.646C391.44 579.633 390.754 580.433 389.908 580.433C389.061 580.433 388.376 579.633 388.376 578.646C388.376 577.66 389.061 576.859 389.908 576.859C390.754 576.859 391.44 577.66 391.44 578.646Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M391.44 570.047C391.44 571.034 390.754 571.834 389.908 571.834C389.061 571.834 388.376 571.034 388.376 570.047C388.376 569.061 389.061 568.26 389.908 568.26C390.754 568.26 391.44 569.061 391.44 570.047Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M391.44 562.008C391.44 562.995 390.754 563.794 389.908 563.794C389.061 563.794 388.376 562.995 388.376 562.008C388.376 561.022 389.061 560.221 389.908 560.221C390.754 560.221 391.44 561.022 391.44 562.008Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M391.44 553.744C391.44 554.731 390.754 555.531 389.908 555.531C389.061 555.531 388.376 554.731 388.376 553.744C388.376 552.758 389.061 551.957 389.908 551.957C390.754 551.957 391.44 552.758 391.44 553.744Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M391.44 545.592C391.44 546.579 390.754 547.378 389.908 547.378C389.061 547.378 388.376 546.579 388.376 545.592C388.376 544.606 389.061 543.805 389.908 543.805C390.754 543.805 391.44 544.606 391.44 545.592Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M391.44 537.437C391.44 538.424 390.754 539.224 389.908 539.224C389.061 539.224 388.376 538.424 388.376 537.437C388.376 536.451 389.061 535.65 389.908 535.65C390.754 535.651 391.44 536.451 391.44 537.437Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M385.441 598.523C385.441 599.633 384.985 600.535 384.422 600.537C383.857 600.541 383.398 599.642 383.398 598.532C383.398 598.528 383.398 598.527 383.398 598.523C383.396 597.414 383.853 596.512 384.418 596.51C384.981 596.508 385.439 597.405 385.441 598.517C385.441 598.519 385.441 598.522 385.441 598.523Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M385.441 590.148C385.441 591.258 384.985 592.16 384.422 592.162C383.857 592.166 383.398 591.267 383.398 590.157C383.398 590.153 383.398 590.152 383.398 590.148C383.396 589.039 383.853 588.137 384.418 588.135C384.981 588.133 385.439 589.03 385.441 590.142C385.441 590.143 385.441 590.147 385.441 590.148Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M385.441 582.443C385.441 583.553 384.985 584.455 384.422 584.457C383.857 584.461 383.398 583.562 383.398 582.452C383.398 582.448 383.398 582.447 383.398 582.443C383.396 581.334 383.853 580.432 384.418 580.43C384.981 580.428 385.439 581.325 385.441 582.436C385.441 582.438 385.441 582.441 385.441 582.443Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M385.441 574.291C385.441 575.4 384.985 576.303 384.422 576.305C383.857 576.309 383.398 575.409 383.398 574.3C383.398 574.296 383.398 574.295 383.398 574.291C383.396 573.182 383.853 572.279 384.418 572.277C384.981 572.275 385.439 573.173 385.441 574.284C385.441 574.284 385.441 574.289 385.441 574.291Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M385.441 565.582C385.441 566.691 384.985 567.594 384.422 567.596C383.857 567.6 383.398 566.7 383.398 565.591C383.398 565.587 383.398 565.586 383.398 565.582C383.396 564.473 383.853 563.57 384.418 563.568C384.981 563.566 385.439 564.464 385.441 565.575C385.441 565.575 385.441 565.58 385.441 565.582Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M385.441 557.65C385.441 558.76 384.985 559.662 384.422 559.664C383.857 559.668 383.398 558.769 383.398 557.659C383.398 557.655 383.398 557.654 383.398 557.65C383.396 556.541 383.853 555.639 384.418 555.637C384.981 555.635 385.439 556.532 385.441 557.644C385.441 557.646 385.441 557.65 385.441 557.65Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M385.441 549.723C385.441 550.832 384.985 551.734 384.422 551.736C383.857 551.74 383.398 550.841 383.398 549.732C383.398 549.728 383.398 549.727 383.398 549.723C383.396 548.613 383.853 547.711 384.418 547.709C384.981 547.707 385.439 548.604 385.441 549.716C385.441 549.718 385.441 549.721 385.441 549.723Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M385.441 541.123C385.441 542.232 384.985 543.135 384.422 543.137C383.857 543.141 383.398 542.241 383.398 541.132C383.398 541.128 383.398 541.127 383.398 541.123C383.396 540.014 383.853 539.111 384.418 539.109C384.981 539.107 385.439 540.005 385.441 541.116C385.441 541.118 385.441 541.123 385.441 541.123Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M385.441 532.973C385.441 534.082 384.985 534.984 384.422 534.986C383.857 534.99 383.398 534.091 383.398 532.982C383.398 532.978 383.398 532.977 383.398 532.973C383.396 531.863 383.853 530.961 384.418 530.959C384.981 530.957 385.439 531.854 385.441 532.966C385.441 532.966 385.441 532.971 385.441 532.973Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M413.271 598.302C413.271 599.35 412.785 600.202 412.187 600.204C411.586 600.206 411.101 599.358 411.101 598.31C411.101 598.308 411.101 598.306 411.101 598.303C411.098 597.254 411.584 596.402 412.184 596.4C412.783 596.398 413.27 597.246 413.271 598.296C413.271 598.296 413.271 598.3 413.271 598.302Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M386.95 405.668H412.227C412.862 405.668 413.376 406.019 413.376 406.45V409.353C413.376 409.784 412.861 410.135 412.227 410.135H386.95C386.316 410.135 385.802 409.784 385.802 409.353V406.45C385.802 406.018 386.316 405.668 386.95 405.668Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M386.95 445.869H412.227C412.862 445.869 413.376 446.22 413.376 446.651V449.554C413.376 449.985 412.861 450.336 412.227 450.336H386.95C386.316 450.336 385.802 449.985 385.802 449.554V446.651C385.802 446.219 386.316 445.869 386.95 445.869Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M386.95 488.752H412.227C412.862 488.752 413.376 489.103 413.376 489.534V492.437C413.376 492.87 412.861 493.219 412.227 493.219H386.95C386.316 493.219 385.802 492.87 385.802 492.437V489.534C385.802 489.102 386.316 488.752 386.95 488.752Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M383.885 342.236H413.247C413.882 342.236 414.396 342.588 414.396 343.018V344.135C414.396 344.565 413.881 344.917 413.247 344.917H383.885C383.25 344.917 382.736 344.565 382.736 344.135V343.018C382.736 342.587 383.252 342.236 383.885 342.236Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M391.035 283.273H411.205C411.84 283.273 412.354 283.625 412.354 284.055V286.065C412.354 286.496 411.839 286.847 411.205 286.847H391.035C390.401 286.847 389.887 286.496 389.887 286.065V284.055C389.887 283.624 390.401 283.273 391.035 283.273Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M391.035 253.793H411.205C411.84 253.793 412.354 254.144 412.354 254.575V256.585C412.354 257.016 411.839 257.367 411.205 257.367H391.035C390.401 257.367 389.887 257.016 389.887 256.585V254.575C389.887 254.143 390.401 253.793 391.035 253.793Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M394.992 233.244H384.779V242.178H394.992V233.244Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M392.951 242.178H385.802V244.858H392.951V242.178Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M391.93 224.311H385.802V233.244H391.93V224.311Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M394.992 219.844H384.779V224.311H394.992V219.844Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M391.93 183.213H385.802V219.842H391.93V183.213Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M392.951 136.758H385.802V155.519H392.951V136.758Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M393.971 153.732H383.759V183.214H393.971V153.732Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M366.397 128.719H363.333V134.079H366.397V128.719Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M382.737 127.824H365.375V134.972H382.737V127.824Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M384.666 137.679C384.687 136.634 383.772 135.621 382.6 135.651L382.658 126.551L385.293 126.556C390.72 126.622 394.393 131.048 394.344 135.671V137.733L384.666 137.679Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M362.159 190.787V188.951H366.267V190.828L362.159 190.787Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M360.165 185.344V189.018L361.123 189.856H367.251L368.272 188.962V185.334L360.165 185.344Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M430.69 190.961V189.123H434.797V190.999L430.69 190.961Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M428.693 185.516V189.19L429.651 190.028H435.779L436.8 189.134V185.506L428.693 185.516Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M430.67 149.624V151.459H434.777V149.584L430.67 149.624Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M428.674 155.086V151.412L429.631 150.574H435.76L436.781 151.468V155.096L428.674 155.086Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M362.109 149.723V151.559H366.216V149.684L362.109 149.723Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M360.113 155.168V151.494L361.071 150.656H367.199L368.22 151.55V155.178L360.113 155.168Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M379.673 182.32H378.651V184.107H379.673V182.32Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M379.673 185.895H378.651V187.681H379.673V185.895Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M418.481 185.895H417.46V187.681H418.481V185.895Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M418.481 182.32H417.46V184.107H418.481V182.32Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M388.69 119.561V121.416L392.752 121.406L392.764 119.58L388.69 119.561Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M387.696 117.785V120.509H393.745V117.785H387.696Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M419.513 119.463V121.318L415.45 121.307L415.439 119.482L419.513 119.463Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M420.507 117.686V120.411H414.459V117.686H420.507Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M393.973 110.85H392.951V111.743H393.973V110.85Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M413.376 110.85H412.354V111.743H413.376V110.85Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M372.356 155.572V162.775L368.305 163.724V169.978",
    fill: "#131F2E"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M372.356 155.572V162.775L368.305 163.724V169.978",
    stroke: "#F7F9F9"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M424.392 155.629L424.439 162.608L428.537 163.569V169.867",
    fill: "#131F2E"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M424.392 155.629L424.439 162.608L428.537 163.569V169.867",
    stroke: "#F7F9F9"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M375.466 168.559L375.436 171.255L375.466 168.559Z",
    fill: "#131F2E"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M375.466 168.559L375.436 171.255",
    stroke: "#F7F9F9"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M421.41 168.57V171.245V168.57Z",
    fill: "#131F2E"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M421.41 168.57V171.245",
    stroke: "#F7F9F9"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M440.95 171.6H429.717V176.96H440.95V171.6Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M367.418 171.6H356.185V176.96H367.418V171.6Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M353.12 173.389H346.992V175.176H353.12V173.389Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M356.041 177.961H352.939L351.884 177.037V171.737L352.957 170.797H356.004L356.041 177.961Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M450.144 173.389H444.016V175.176H450.144V173.389Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M440.799 177.964H443.898L444.955 177.04V171.74L443.88 170.799H440.771L440.799 177.964Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M421.546 104.596H386.822V109.956H421.546V104.596Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M413.375 84.9414H394.992V104.596H413.375V84.9414Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M387.683 102.379V100.523L391.746 100.534L391.759 102.36L387.683 102.379Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M386.69 104.155V101.43H392.739V104.155H386.69Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M420.384 102.379V100.523L416.32 100.534L416.31 102.36L420.384 102.379Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M421.377 104.155V101.43H415.328V104.155H421.377Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M411.173 102.379V100.523L407.111 100.534L407.099 102.36L411.173 102.379Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M412.166 104.155V101.43H406.117V104.155H412.166Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M396.894 102.363V100.508L400.957 100.518L400.968 102.343L396.894 102.363Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M395.902 104.14V101.416H401.951V104.14H395.902Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M387.738 87.2578V89.1133L391.802 89.1034L391.815 87.2777L387.738 87.2578Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M386.747 85.4824V88.2065H392.796V85.4824H386.747Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M420.438 87.2578V89.1133L416.375 89.1034L416.364 87.2777L420.438 87.2578Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M421.432 85.4824V88.2065H415.384V85.4824H421.432Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M411.227 87.2578V89.1133L407.166 89.1034L407.153 87.2777L411.227 87.2578Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M412.222 85.4824V88.2065H406.174V85.4824H412.222Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M396.95 87.2734V89.129L401.014 89.119L401.024 87.2934L396.95 87.2734Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M395.959 85.498V88.2222H402.007V85.498H395.959Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M421.546 78.6875H386.822V84.9416H421.546V78.6875Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M421.546 47.418H386.822V53.6721H421.546V47.418Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M421.546 54.5664H386.822V77.794H421.546V54.5664Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M387.675 45.2696V43.4141L391.736 43.424L391.749 45.2497L387.675 45.2696Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M386.683 47.0464V44.3223H392.731V47.0464H386.683Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M420.374 45.2696V43.4141L416.312 43.424L416.3 45.2497L420.374 45.2696Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M421.368 47.0464V44.3223H415.319V47.0464H421.368Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M413.375 39.3809H394.992V47.4209H413.375V39.3809Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M411.162 45.2696V43.4141L407.1 43.424L407.088 45.2497L411.162 45.2696Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M412.155 47.0464V44.3223H406.106V47.0464H412.155Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M396.886 45.254V43.3984L400.947 43.4084L400.96 45.2341L396.886 45.254Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M395.892 47.0298V44.3047H401.94V47.0298H395.892Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M394.822 39.4851L391.794 37.6982V24.2637L416.308 24.2945V37.729L413.175 39.5468L394.822 39.4851Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M391.813 34.217L387.655 30.5786V25.1095L388.689 24.2051H391.716L391.813 34.217Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M416.324 34.1295L420.408 30.5119V25.195L419.338 24.2578H416.274L416.324 34.1295Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M400.95 22.4765V13.541H407.079V16.284H409.192V19.7971H407.114V22.4785L400.95 22.4765Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M410.312 22.4043H398.057V24.1912H410.312V22.4043Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M404.018 35.0882L401.976 33.1709V24.2812H406.061V33.1709L404.018 35.0882Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M409.186 16.6079L411.192 16.6L411.21 14.8201L412.187 13.9336H413.244L414.265 14.8051L414.275 21.0523L413.272 21.9686H412.206L411.211 21.0135L411.193 19.2953L409.195 19.3261L409.186 16.6079Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M410.789 6.85416C410.789 10.0877 407.792 12.7083 404.096 12.7083C400.4 12.7083 397.404 10.0867 397.404 6.85416C397.404 3.62064 400.401 1 404.096 1C407.792 1 410.789 3.62164 410.789 6.85416Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M404.115 6.86914L407.179 8.64111L404.115 6.86914Z",
    fill: "#131F2E"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M404.115 6.86914L407.179 8.64111",
    stroke: "#F7F9F9"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M404.679 6.83889C404.679 7.10255 404.433 7.31546 404.133 7.31546C403.833 7.31546 403.587 7.10155 403.587 6.83889C403.587 6.57523 403.831 6.36133 404.133 6.36133C404.434 6.36133 404.679 6.57424 404.679 6.83889Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M405.206 66.1797H404.185V67.0731H405.206V66.1797Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M471.588 59.0332H428.693V74.2208H471.588V59.0332Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M429.717 54.5664H422.567V78.6875H429.717V54.5664Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M433.8 55.4609H431.758V58.1413H433.8V55.4609Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M432.78 54.5664H430.737V59.0336H432.78V54.5664Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M433.8 61.7148H431.758V64.3952H433.8V61.7148Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M431.76 60.8203H429.717V65.2875H431.76V60.8203Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M433.8 68.8613H431.758V71.5417H433.8V68.8613Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M431.76 67.9668H429.717V72.434H431.76V67.9668Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M433.8 75.1133H431.758V77.7936H433.8V75.1133Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M431.76 74.2207H429.717V78.688H431.76V74.2207Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M477.717 54.5664H470.567V78.6875H477.717V54.5664Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M468.524 55.4609H466.481V58.1413H468.524V55.4609Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M469.546 54.5664H467.503V59.0336H469.546V54.5664Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M468.524 61.7148H466.481V64.3952H468.524V61.7148Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M469.546 60.8203H467.503V65.2875H469.546V60.8203Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M468.524 68.8613H466.481V71.5417H468.524V68.8613Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M469.546 67.9668H467.503V72.434H469.546V67.9668Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M468.524 75.1133H466.481V77.7936H468.524V75.1133Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M469.546 74.2207H467.503V78.688H469.546V74.2207Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M485.888 54.5664H478.738V78.6875H485.888V54.5664Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M507.334 80.4746H500.185V87.6222H507.334V80.4746Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M494.913 55.5527V78.7982C500.026 83.2714 507.236 83.2545 512.335 78.7982L512.357 55.5527H494.913Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M485.715 74.2547H494.876C498.883 69.1129 498.782 64.0627 494.876 59.1328H485.715V74.2547Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M489.972 55.4609H487.93V58.1413H489.972V55.4609Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M487.929 54.5664H485.887V59.0336H487.929V54.5664Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M489.972 61.7148H487.93V64.3952H489.972V61.7148Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M487.929 60.8203H485.887V65.2875H487.929V60.8203Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M489.972 68.8613H487.93V71.5417H489.972V68.8613Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M487.929 67.9668H485.887V72.434H487.929V67.9668Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M489.972 75.1133H487.93V77.7936H489.972V75.1133Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M487.929 74.2207H485.887V78.688H487.929V74.2207Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M464.322 66.7136C464.312 73.3865 458.119 78.788 450.491 78.779C442.88 78.7701 436.709 73.3736 436.699 66.7136C436.689 60.0406 442.863 54.6242 450.491 54.6152C458.119 54.6063 464.312 60.0078 464.322 66.6807C464.322 66.6907 464.322 66.7016 464.322 66.7136Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M442.792 70.1103C442.797 71.156 441.831 72.0076 440.635 72.0126C439.438 72.0166 438.465 71.1709 438.46 70.1242C438.46 70.1202 438.46 70.1153 438.46 70.1113C438.455 69.0646 439.423 68.213 440.618 68.209C441.814 68.205 442.788 69.0507 442.792 70.0974C442.792 70.1013 442.792 70.1063 442.792 70.1103Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M442.861 63.2607C442.865 64.3074 441.899 65.159 440.703 65.163C439.506 65.167 438.533 64.3213 438.528 63.2746C438.528 63.2697 438.528 63.2657 438.528 63.2617C438.524 62.215 439.492 61.3634 440.686 61.3594C441.882 61.3554 442.856 62.2011 442.861 63.2478C442.861 63.2517 442.861 63.2557 442.861 63.2607Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M448.417 58.1953C448.422 59.2419 447.454 60.0936 446.258 60.0976C445.062 60.1015 444.09 59.2559 444.083 58.2102C444.083 58.2052 444.083 58.2012 444.083 58.1962C444.078 57.1506 445.046 56.2989 446.243 56.2949C447.439 56.29 448.413 57.1367 448.417 58.1823C448.417 58.1863 448.417 58.1903 448.417 58.1953Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M456.818 58.1503C456.823 59.197 455.856 60.0487 454.66 60.0526C453.463 60.0566 452.49 59.2109 452.485 58.1653C452.485 58.1603 452.485 58.1553 452.485 58.1513C452.481 57.1057 453.449 56.254 454.645 56.25C455.841 56.245 456.813 57.0917 456.818 58.1374C456.818 58.1414 456.818 58.1464 456.818 58.1503Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M448.569 75.2822C448.573 76.3289 447.606 77.1805 446.409 77.1845C445.214 77.1885 444.241 76.3428 444.234 75.2961C444.234 75.2921 444.234 75.2872 444.234 75.2832C444.23 74.2365 445.198 73.3858 446.394 73.3809C447.591 73.3769 448.564 74.2226 448.569 75.2693C448.569 75.2732 448.569 75.2782 448.569 75.2822Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M462.517 63.2802C462.522 64.3259 461.554 65.1776 460.357 65.1815C459.161 65.1855 458.187 64.3398 458.183 63.2942C458.183 63.2892 458.183 63.2852 458.183 63.2812C458.178 62.2346 459.146 61.3829 460.342 61.3789C461.539 61.3749 462.51 62.2206 462.517 63.2673C462.517 63.2713 462.517 63.2763 462.517 63.2802Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M462.517 70.1874C462.522 71.2341 461.554 72.0858 460.357 72.0897C459.161 72.0937 458.187 71.248 458.183 70.2014C458.183 70.1964 458.183 70.1924 458.183 70.1884C458.178 69.1428 459.146 68.2911 460.342 68.2871C461.539 68.2831 462.51 69.1278 462.517 70.1745C462.517 70.1785 462.517 70.1835 462.517 70.1874Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M456.784 75.2431C456.789 76.2898 455.821 77.1414 454.627 77.1454C453.43 77.1494 452.457 76.3037 452.452 75.2571C452.452 75.2531 452.452 75.2481 452.452 75.2441C452.448 74.1975 453.413 73.3458 454.61 73.3418C455.806 73.3378 456.78 74.1835 456.784 75.2302C456.784 75.2342 456.784 75.2382 456.784 75.2431Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M441.298 98.5014L448.025 66.2747C448.635 63.2243 453.528 63.8401 452.912 67.0856L446.503 99.4874C445.762 102.49 440.504 101.433 441.298 98.5014Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M451.027 66.6728C451.027 66.9335 450.784 67.1454 450.485 67.1454C450.188 67.1454 449.944 66.9335 449.944 66.6728C449.944 66.4111 450.188 66.1992 450.485 66.1992C450.783 66.2002 451.027 66.4111 451.027 66.6728Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M515.504 86.7285H492.014V92.0892H515.504V86.7285Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M493.886 50.1699C491.347 51.127 491.425 55.5933 493.886 56.4479H513.338C515.835 55.5614 515.862 51.0952 513.338 50.1699H493.886Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M506.313 24.1914H502.228V29.5521H506.313V24.1914Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M497.045 50.1702V30.5084C500.009 28.2927 507.134 28.2798 510.268 30.5084V50.1712L497.045 50.1702Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M482.646 20.6775C480.04 20.6725 479.928 24.2274 482.646 24.2712H525.57C528.498 24.2045 528.393 20.6934 525.57 20.6387L482.646 20.6775Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M433.665 171.682V177.097V171.682Z",
    fill: "#131F2E"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M433.665 171.682V177.097",
    stroke: "#F7F9F9"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M400.099 350.277H398.057V352.064H400.099V350.277Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M384.78 350.277H383.759V352.064H384.78V350.277Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M413.376 350.277H412.354V352.064H413.376V350.277Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M396.078 595.07H408.174H396.078Z",
    fill: "#131F2E"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M396.078 595.07H408.174",
    stroke: "#F7F9F9"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M392.919 591.516H411.741H392.919Z",
    fill: "#131F2E"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M392.919 591.516H411.741",
    stroke: "#F7F9F9"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M391.746 572.801H412.237H391.746Z",
    fill: "#131F2E"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M391.746 572.801H412.237",
    stroke: "#F7F9F9"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M391.789 570.627H412.326H391.789Z",
    fill: "#131F2E"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M391.789 570.627H412.326",
    stroke: "#F7F9F9"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M391.789 575.486H412.369L405.342 580.743L398.498 580.717L391.789 575.486Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M410.297 512.076H393.234H410.297Z",
    fill: "#131F2E"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M410.297 512.076H393.234",
    stroke: "#F7F9F9"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M412.237 510.26H391.159H412.237Z",
    fill: "#131F2E"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M412.237 510.26H391.159",
    stroke: "#F7F9F9"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M408.807 505.838H395.583H408.807Z",
    fill: "#131F2E"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M408.807 505.838H395.583",
    stroke: "#F7F9F9"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M412.327 460.67H391.881H412.327Z",
    fill: "#131F2E"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M412.327 460.67H391.881",
    stroke: "#F7F9F9"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M412.101 457.947H391.971H412.101Z",
    fill: "#131F2E"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M412.101 457.947H391.971",
    stroke: "#F7F9F9"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M411.898 400.873H391.452H411.898Z",
    fill: "#131F2E"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M411.898 400.873H391.452",
    stroke: "#F7F9F9"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M411.673 398.15H391.543H411.673Z",
    fill: "#131F2E"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M411.673 398.15H391.543",
    stroke: "#F7F9F9"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M399.103 381.586H408.986H399.103Z",
    fill: "#131F2E"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M399.103 381.586H408.986",
    stroke: "#F7F9F9"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M397.838 365.518H410.296H397.838Z",
    fill: "#131F2E"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M397.838 365.518H410.296",
    stroke: "#F7F9F9"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M397.929 357.463H410.161H397.929Z",
    fill: "#131F2E"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M397.929 357.463H410.161",
    stroke: "#F7F9F9"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M383.665 352.645H413.228H383.665Z",
    fill: "#131F2E"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M383.665 352.645H413.228",
    stroke: "#F7F9F9"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M383.885 335.982H413.247C413.882 335.982 414.396 336.334 414.396 336.764V337.881C414.396 338.312 413.881 338.663 413.247 338.663H383.885C383.25 338.663 382.736 338.312 382.736 337.881V336.764C382.736 336.333 383.252 335.982 383.885 335.982Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M393.396 26.648L394.429 24.9688L393.396 26.648Z",
    fill: "#131F2E"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M393.396 26.648L394.429 24.9688",
    stroke: "#F7F9F9"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M391.354 24.7821L393.035 23.8242L391.354 24.7821Z",
    fill: "#131F2E"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M391.354 24.7821L393.035 23.8242",
    stroke: "#F7F9F9"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M390.734 22.166H392.647H390.734Z",
    fill: "#131F2E"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M390.734 22.166H392.647",
    stroke: "#F7F9F9"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M391.501 19.6211L393.146 20.506L391.501 19.6211Z",
    fill: "#131F2E"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M391.501 19.6211L393.146 20.506",
    stroke: "#F7F9F9"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M393.467 17.8242L394.443 19.3453L393.467 17.8242Z",
    fill: "#131F2E"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M393.467 17.8242L394.443 19.3453",
    stroke: "#F7F9F9"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M396.11 17.1094V18.9398V17.1094Z",
    fill: "#131F2E"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M396.11 17.1094V18.9398",
    stroke: "#F7F9F9"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M398.752 17.8242L397.801 19.3779L398.752 17.8242Z",
    fill: "#131F2E"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M398.752 17.8242L397.801 19.3779",
    stroke: "#F7F9F9"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M400.701 19.6914L399.079 20.5324L400.701 19.6914Z",
    fill: "#131F2E"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M400.701 19.6914L399.079 20.5324",
    stroke: "#F7F9F9"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M401.394 22.1152H399.518H401.394Z",
    fill: "#131F2E"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M401.394 22.1152H399.518",
    stroke: "#F7F9F9"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M400.811 24.7463L399.042 23.748L400.811 24.7463Z",
    fill: "#131F2E"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M400.811 24.7463L399.042 23.748",
    stroke: "#F7F9F9"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M398.77 26.6133L397.783 25.0254L398.77 26.6133Z",
    fill: "#131F2E"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M398.77 26.6133L397.783 25.0254",
    stroke: "#F7F9F9"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M401.477 22.2174C401.477 25.0734 399.056 27.388 396.072 27.388C393.088 27.388 390.669 25.0725 390.669 22.2174C390.669 19.3624 393.089 17.0469 396.072 17.0469C399.056 17.0469 401.477 19.3615 401.477 22.2174Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M381.734 217.502H384.395H381.734Z",
    fill: "#131F2E"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M381.734 217.502H384.395",
    stroke: "#F7F9F9"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M385.179 217.502H384.376H385.179Z",
    fill: "#131F2E"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M385.179 217.502H384.376",
    stroke: "#F7F9F9"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M380.371 162.277L383.728 162.266L380.371 162.277Z",
    fill: "#131F2E"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M380.371 162.277L383.728 162.266",
    stroke: "#F7F9F9"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M384.513 162.266H383.711H384.513Z",
    fill: "#131F2E"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M384.513 162.266H383.711",
    stroke: "#F7F9F9"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M369.09 168.682V171.82V168.682Z",
    fill: "#131F2E"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M369.09 168.682V171.82",
    stroke: "#F7F9F9"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M413.91 168.508V171.646V168.508Z",
    fill: "#131F2E"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M413.91 168.508V171.646",
    stroke: "#F7F9F9"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M151.616 206.9H214.348H151.616Z",
    fill: "#131F2E"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M151.616 206.9H214.348",
    stroke: "#F7F9F9"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M271.658 206.064H302.506H271.658Z",
    fill: "#131F2E"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M271.658 206.064H302.506",
    stroke: "#F7F9F9"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M0 211L533 211",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeterminePump);
export default __webpack_public_path__ + "static/media/determine-pump.87b15fd92a144c834da5315daf89b670.svg";
export { ForwardRef as ReactComponent };